import {intlShape, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';

class FilterNodeItemLabel extends React.PureComponent {
  render() {
    const {intl, label} = this.props;
    return (
      <span>
        {utils.TranslateUtils.hasTranslation(label, intl) ? (
          <FormattedMessage id={label} description={'filter node item label'} />
        ) : (
          label
        )}
      </span>
    );
  }
}

FilterNodeItemLabel.displayName = 'FilterNodeItemLabel';

FilterNodeItemLabel.propTypes = {
  intl: intlShape.isRequired,
  label: PropTypes.string,
};

FilterNodeItemLabel.defaultProps = {
  label: '',
};

export default injectIntl(FilterNodeItemLabel);
